import ThemeSwitcher from './themeSwitcher/reducer';
import Auth from './Auth/reducer';
import App from './App/reducer';
import Dashboard from './Dashboard/reducer';
import Shoebox from './Shoebox/reducer';
import ShoeboxTransaction from './ShoeboxTransaction/reducer';
import Partner from './Partner/reducer';
import Subscription from './Subscription/reducer';
import Coupon from './Coupon/reducer';
import Plan from './Plan/reducer';
import Opening from './Opening/reducer';
import BatchInvoicing from './BatchInvoicing/reducer';
import Import from './Import/reducer';
import Inventory from './Inventory/reducer';
import Tag from './Tag/reducer';
import Annotation from './Annotation/reducer';
import Test from './Test/reducer';
import List from './List/reducer';
import User from './User/reducer';
import Search from './Search/reducer';
import Form from './Form/reducer';
import Transaction from './Transaction/reducer';
import PublicTransaction from './PublicTransaction/reducer';
import PublicStatement from './PublicStatement/reducer';
import Contact from './Contact/reducer';
import Product from './Product/reducer';
import ProductBundle from './ProductBundle/reducer';
import ProductGroup from './ProductGroup/reducer';
import Account from './Account/reducer';
import Report from './Report/reducer';
import Setting from './Setting/reducer';
import Company from './Company/reducer';
import Access from './Access/reducer';
import Currency from './Currency/reducer';
import Term from './Term/reducer';
import Instruction from './Instruction/reducer';
import BankAccount from './BankAccount/reducer';
import ContactGroup from './ContactGroup/reducer';
import Reconciliation from './Reconciliation/reducer';
import Extension from './Extension/reducer';
import Asset from './Asset/reducer';
import Location from './Location/reducer';
import StockTransfer from './StockTransfer/reducer';
import Field from './Field/reducer';
import NumberFormat from './NumberFormat/reducer';
import StockBalance from './StockBalance/reducer';
import Audit from './Audit/reducer';
import Editable from './EditableTable/reducer';
import LocalStorage from './LocalStorage/reducer';
import File from './File/reducer';
import Notification from './Notification/reducer';
import ContactAddress from './ContactAddress/reducer';
import Store from './Store/reducer';
import StoreSetting from './StoreSetting/reducer';
import PaymentMethod from './PaymentMethod/reducer';
import PriceLevel from './PriceLevel/reducer';
import FormDesign from './FormDesign/reducer';
import Payroll from './Payroll/reducer';
import PublicList from './PublicList/reducer';
import Backup from './Backup/reducer';
import TransactionTransfer from './TransactionTransfer/reducer';
import Logger from './Logger/reducer';
import Lightbox from './Lightbox/reducer';
import Quota from './Quota/reducer';
import BankFeed from './BankFeed/reducer';
import Financing from './Financing/reducer';
import Flow from './Flow/reducer';
import AuditModule from './AuditModule/reducer';
import ContactMyinvoisData from './ContactMyinvoisData/reducer';
import Otp from './Otp/reducer';
import MyInvois from './MyInvois/reducer';
import Ai from './Ai/reducer';
import PublicMiniPosOrder from './PublicMiniPosOrder/reducer';
import MiniPos from './MiniPos/reducer';
import AppCp from './AppCp/reducer';
import BukkuAdmin from './BukkuAdmin/reducer';
import PublicPricingTransition from './PublicPricingTransition/reducer';

export default {
    ThemeSwitcher, //

    App,
    Auth,
    Dashboard,
    Shoebox,
    ShoeboxTransaction,
    Partner,
    Subscription,
    Coupon,
    Plan,
    Opening,
    BatchInvoicing,
    Import,
    Inventory,
    Tag,
    Annotation,
    Test,
    List,
    User,
    Search,
    Form,
    Transaction,
    PublicTransaction,
    PublicStatement,
    Contact,
    Product,
    ProductBundle,
    ProductGroup,
    Account,
    Report,
    Setting,
    Company,
    Access,
    Currency,
    Term,
    Instruction,
    BankAccount,
    ContactGroup,
    Reconciliation,
    Extension,
    Asset,
    Location,
    StockTransfer,
    Field,
    NumberFormat,
    StockBalance,
    Audit,
    Editable,
    LocalStorage,
    File,
    Notification,
    ContactAddress,
    Store,
    StoreSetting,
    PaymentMethod,
    PriceLevel,
    FormDesign,
    Payroll,
    PublicList,
    Backup,
    TransactionTransfer,
    Logger,
    Lightbox,
    Quota,
    BankFeed,
    Financing,
    Flow,
    AuditModule,
    ContactMyinvoisData,
    Otp,
    MyInvois,
    Ai,
    PublicMiniPosOrder,
    MiniPos,
    AppCp,
    BukkuAdmin,
    PublicPricingTransition,
};
